export const toPhoneCall = (mobile: number | string) => {
  const url = `tel:${mobile}`;
  window.location.href = url;
};
/**
 * OPay的JsBridge对象
 */
/**
 * 动态设置css全局变量实现旋转
 * transform: rotate(var(--image-rotate))
 * @param deg 旋转角度
 * @param prop css变量, 默认'--image-rotate'
 */
export const setRotate = (deg: string, prop = '--image-rotate') => {
  let rotate = document.documentElement.style.getPropertyValue(prop) || '0deg';
  if (typeof deg === 'string') {
    rotate = deg;
  } else {
    rotate = parseInt(rotate) + 90 + 'deg';
  }
  document.documentElement.style.setProperty(prop, rotate);
};
//  打开app 或者去gp下载
export const  openApp = (link='') => {
  try {
      window.location.href = link;
      setTimeout(function(){
        window.location.href= "https://play.google.com/store/apps/details?id=credit.prestamos.personale.cash.didi.tala.okredito"; //android下载地址
      },2000);
  } catch(e) {}
}
/**
 * 是否为 Android环境
 * @returns {Boolean}
 */
 export const isAndroid = () =>
   navigator.userAgent.includes('Android') || navigator.userAgent.includes('Adr')
 


/**
 * 判断是否为移动端
 * @returns
 */
export const isMobile = () => {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian)/i
  );
};
/**
 * 判断设备类型
 * @returns
 */
export const detectDevice = () => {
  const userAgent = navigator.userAgent;
  // 判断是否是iOS设备（iPhone、iPad、iPod）
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  // 判断是否是安卓设备
  const isAndroid = /Android/i.test(userAgent);
  
  if (isIOS) {
      return 2; //'iOS'
  } else if (isAndroid) {
      return 1; //'Android'
  } else {
      return 3; // 'PC'
  }
};


export const formateMoney = (num = 0, str = ',') => {
  if(!num) return 0
  else {
    return num?.toString().replace(/\d+/, function (n) {
      return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + str)
    })
  }
}

export  const infoStepArr = 
{
    1001: '/infoWish',
    1002: '/infoSelf',
    1003: '/infoJob',
    1004: '/infoContact',
    1005: '/infoCard',
    1006: '/infoOcr',
    1110: '/infoOcr',
  }

  export   const infoList2 = {
    1001: '/infoWish',
    1002: '/infoSelf',
    1003: '/infoJob',
    1004: '/infoContact',
    1005: '/infoCard',
    1006: '/infoOcr',
  };

  export const timeFunction = (time:any, hsm:any) => {
    var date = new Date(time)
    var Y = date.getFullYear()
    var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  
    return `${D}/${M}/${Y}`
  }
  